import type { ModuleName } from '@voge/shared';
import {
  Boxes,
  Brain,
  Building2,
  CreditCard,
  GitCompareArrows,
  Headphones,
  LayoutDashboard,
  type LucideIcon,
  MapPin,
  Megaphone,
  MessageSquare,
  Package,
  Plug,
  Receipt,
  ShoppingCart,
  TrendingUp,
  Truck,
  Users,
  Warehouse,
} from 'lucide-react';

export type NavGroup = 'main' | 'analytics' | 'management';

export interface NavItem {
  module: ModuleName;
  label: string;
  path: string;
  icon: LucideIcon;
  group: NavGroup;
}

export const NAV_GROUPS: { id: NavGroup; label: string }[] = [
  { id: 'main', label: 'Главное' },
  { id: 'analytics', label: 'Аналитика' },
  { id: 'management', label: 'Управление' },
];

export const NAV_ITEMS: NavItem[] = [
  { module: 'overview', label: 'Обзор', path: '/', icon: LayoutDashboard, group: 'main' },
  { module: 'sales', label: 'Продажи', path: '/sales', icon: Receipt, group: 'main' },
  {
    module: 'inventory',
    label: 'Остатки дилеров',
    path: '/inventory',
    icon: Warehouse,
    group: 'main',
  },
  { module: 'map', label: 'Остатки на карте', path: '/map', icon: MapPin, group: 'main' },
  {
    module: 'tdPikInventory',
    label: 'Остатки ТД-ПИК',
    path: '/td-pik-inventory',
    icon: Building2,
    group: 'main',
  },
  {
    module: 'stockOptimization',
    label: 'Оптимизация запасов',
    path: '/stock-optimization',
    icon: Boxes,
    group: 'main',
  },
  { module: 'quotas', label: 'Квоты', path: '/quotas', icon: TrendingUp, group: 'main' },
  { module: 'orders', label: 'Заказы', path: '/orders', icon: ShoppingCart, group: 'main' },
  { module: 'logistics', label: 'Логистика', path: '/logistics', icon: Truck, group: 'main' },
  {
    module: 'contactCenter',
    label: 'Контакт-центр',
    path: '/contact-center',
    icon: Headphones,
    group: 'main',
  },
  {
    module: 'credit',
    label: 'Кредиты и рассрочка',
    path: '/credit',
    icon: CreditCard,
    group: 'main',
  },
  {
    module: 'messengers',
    label: 'Коммуникации',
    path: '/messengers',
    icon: MessageSquare,
    group: 'main',
  },
  {
    module: 'analytics',
    label: 'Аналитика',
    path: '/analytics',
    icon: Package,
    group: 'analytics',
  },
  {
    module: 'marketing',
    label: 'Маркетинг',
    path: '/marketing',
    icon: Megaphone,
    group: 'analytics',
  },
  {
    module: 'aiAnalytics',
    label: 'AI-аналитика',
    path: '/ai-analytics',
    icon: Brain,
    group: 'analytics',
  },
  {
    module: 'compare',
    label: 'Сравнение',
    path: '/compare',
    icon: GitCompareArrows,
    group: 'analytics',
  },
  { module: 'team', label: 'Команда', path: '/team', icon: Users, group: 'management' },
  {
    module: 'integrations',
    label: 'Интеграции',
    path: '/integrations',
    icon: Plug,
    group: 'management',
  },
];
